import {useEffect} from "react";
import '../../../static/css/home/honors.css';
import {ServerImage} from "../../../components/api/webservice";

export const HomeHonorsScreen = () => {
    useEffect(() => {
        document.title = "افتخارات | مدرسه هوشمند نهال";
    }, []);
    return (
        <>
            <div style={{background: '#fff'}}>
                <div className="container">
                    <div className="gallery-title">
                        <div>
                            <i/>
                            <em/>
                            <h1>افتخارات نهال</h1>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4">
                            <img src={ServerImage('honor1.jpg')} alt="" className="home-honor-img"/>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <img src={ServerImage('honor2.jpg')} alt="" className="home-honor-img"/>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <img src={ServerImage('honor3.jpg')} alt="" className="home-honor-img"/>
                        </div>
                    </div>
                    <div style={{height:40}}/>
                </div>
            </div>
        </>
    );
};